import classNames from "classnames";
import noop from "lodash/noop";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import useCartContext from "@Hooks/useCartContext";
import { ReactComponent as IconTruck } from "@Icons/colored/truck.svg";
import { Currency } from "@Types/api/price";
import "./style.scss";

interface Props extends ContainerProps {
  amountUntilPromo: number;
  appliablePromo: boolean;
  currency: Currency;
  promoCode: string;
}

interface ContainerProps {
  onUpdatePromoCode: (promoCode: string) => void;
}

export const CartFreeShippingBanner: FunctionComponent<Props> = ({
  amountUntilPromo,
  appliablePromo,
  currency,
  onUpdatePromoCode,
  promoCode,
}) => {
  const intl = useIntl();

  return (
    <div
      className={classNames("CartFreeShippingBanner", {
        "CartFreeShippingBanner--clickable": appliablePromo,
      })}
      onClick={appliablePromo ? () => onUpdatePromoCode(promoCode) : noop}
    >
      <IconTruck />
      {!appliablePromo ? (
        <div>
          {intl.formatMessage(
            { id: "cheerz_CartFreeShippingBanner_get_free_shipping" },
            {
              value: (
                <span className="CartFreeShippingBanner-value">
                  {intl.formatNumber(amountUntilPromo, {
                    currency,
                    minimumFractionDigits: 2,
                    style: "currency",
                  })}
                </span>
              ),
            }
          )}
        </div>
      ) : (
        <>
          <div>
            {intl.formatMessage(
              { id: "cheerz_CartFreeShippingBanner_free_shipping_available" },
              { code: <span className="CartFreeShippingBanner-code">WOW</span> }
            )}
          </div>
          <ButtonSmily size="xs" type="secondary">
            {intl.formatMessage({ id: "cheerz_CartFreeShippingBanner_apply" })}
          </ButtonSmily>
        </>
      )}
    </div>
  );
};

const CartFreeShippingBannerContainer: FunctionComponent<ContainerProps> = ({
  onUpdatePromoCode,
}) => {
  const { cart } = useCartContext();

  return (
    <>
      {!!cart.freeShippingConfig ? (
        <CartFreeShippingBanner
          amountUntilPromo={cart.freeShippingConfig.amountUntilPromo.cents / 100}
          appliablePromo={cart.freeShippingConfig.appliablePromo}
          currency={cart.freeShippingConfig.amountUntilPromo.currency}
          onUpdatePromoCode={onUpdatePromoCode}
          promoCode={cart.freeShippingConfig.promoCode}
        />
      ) : null}
    </>
  );
};

export default CartFreeShippingBannerContainer;
